import Box from "@mui/material/Box";
import { useStyles } from "./styles";
import { Tab, Tabs, useTheme } from "@mui/material";
import { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { useNavigate, useLocation } from "react-router-dom";
import { UserContext } from "context/userContext";

const urlToValueMap = {
  users: 0,
  roles: 1,
  permissions: 2,
  suppliers: 3,
};

export default function UserManagementTabs({ isNavbarOpen, ...props }) {
  const theme = useTheme();
  const classes = useStyles({ theme, isNavbarOpen });
  const navigate = useNavigate();
  const location = useLocation();
  const userContextValue = useContext(UserContext) || {};

  const pathParts = location.pathname.split("/");
  const id = pathParts[pathParts.length - 1];
  const loggedInUserType = userContextValue?.loggedInUser?.user_type;
  const tabs = [
    { id: 0, label: "Users", allowedUserTypes: [1, 2, 3, 4] },
    { id: 1, label: "Roles", allowedUserTypes: [1, 2, 3] },
    { id: 2, label: "Permissions", allowedUserTypes: [1, 2, 3] },
    { id: 3, label: "Suppliers", allowedUserTypes: [1] },
  ];

  const getInitialTabValue = () => {
    if (location?.state?.activeTab) {
      return urlToValueMap[location.state.activeTab] !== undefined
        ? urlToValueMap[location.state.activeTab]
        : 0;
    }
    return urlToValueMap[id] !== undefined ? urlToValueMap[id] : 0;
  };

  const [value, setValue] = useState(getInitialTabValue());

  useEffect(() => {
    if (!location?.state?.activeTab) {
      const tabValue = urlToValueMap[id] !== undefined ? urlToValueMap[id] : 0;
      setValue(tabValue);
    }
  }, [id, location.pathname, location.state]);

  const handleChange = (event, newValue) => {
    const tabName = tabs[newValue]?.label.toLowerCase();
    navigate(`/usermanagement/${tabName}`);
    setValue(newValue);
  };

  return (
    <Box className={classes.tabsHeaderContainer}>
      <Box className={classes.tabsWrapper}>
        <Tabs
          TabIndicatorProps={{
            style: {
              display: "none",
            },
          }}
          value={value}
          onChange={handleChange}
          aria-label="Tabs"
          centered
        >
          {tabs.map(
            (tab) =>
              tab.allowedUserTypes.includes(loggedInUserType) && (
                <Tab
                  className={classes.tab}
                  data-testid={`tab-${tab.id}`}
                  sx={{
                    ...(tab.id === value
                      ? {
                          background: "#EDF1F5 !important",
                          color: "#5B5D6E !important",
                        }
                      : { color: "#ffff !important" }),
                  }}
                  key={tab.id}
                  label={tab.label}
                />
              )
          )}
        </Tabs>
      </Box>
    </Box>
  );
}

UserManagementTabs.propTypes = {
  isNavbarOpen: PropTypes.bool,
};
